module.exports = __webpack_public_path__ + "static/Madetobestrong_All_Mesh_Body-265294a8c67805c33e3f5d53feaa1c9f.png";